import React, { Component } from "react";
import { Container, Dimmer, Loader, Tab } from "semantic-ui-react";
import Heading from "../../components/Header";
import fire from "../../config/config";
import Packages from "./Packages";
import SupportMsg from "./SupportMsg";
import TobesentBtcAndTbc from "./TobesentBtcAndTbc";

import { Redirect } from "react-router-dom";

export default class AdminDashboard extends Component {
  state = {
    users: [],
    loading: true,
    signedInAndAdmin: false,
    signedInAndNotAdmin: false,
    notSignedIn: false
  };

  componentDidMount() {
    //var user = fire.auth().currentUser;

    fire.auth().onAuthStateChanged(user => {
      //console.log("user:", user);

      if (user != null) {
        //user signed in
        //check if the currenet user is an admin or not
        fire
          .database()
          .ref("users")
          .orderByChild("email")
          .equalTo(user.email)
          .once("value", snap => {
            var data = snap.val();
            var adminStatus;
            for (let i in data) {
              adminStatus = data[i].admin;
              //console.log("admin status:", adminStatus);
            }
            if (adminStatus === true) {
              //signedIn and admin
              //show the list of users
              fire
                .database()
                .ref("users")
                .on("value", snap => {
                  var data = snap.val();
                  var users = [];
                  for (let i in data) {
                    users.push({ ...data[i], key: i });
                  }
                  //console.log("users:", users);
                  this.setState({
                    signedInAndAdmin: true,
                    loading: false,
                    users: users
                  });
                });
            } else {
              // signedIn but not admin
              this.setState({ loading: false, signedInAndNotAdmin: true });
            }
          });
      } else {
        this.setState({ loading: false, notSignedIn: true });
      }
    });
  }

  render() {
    const { loading, signedInAndNotAdmin, notSignedIn } = this.state;
    //console.log("loading:", loading);

    if (loading) {
      return (
        <Container>
          <Dimmer active inverted>
            <Loader size="large">Loading</Loader>
          </Dimmer>
        </Container>
      );
    }

    if (signedInAndNotAdmin) {
      return <Redirect to="/dashboard" />;
    }

    if (notSignedIn) {
      return <Redirect to="/login" />;
    }

    return (
      <Container>
        <Heading />
        <p style={{ padding: 20 }} />

        <Tab
          panes={[
            {
              menuItem: "Purchased packages",
              render: () => (
                <Tab.Pane>
                  <Packages />
                </Tab.Pane>
              )
            },
            {
              menuItem: "Support messages",
              render: () => (
                <Tab.Pane>
                  <SupportMsg />
                </Tab.Pane>
              )
            },
            {
              menuItem: "Expired packages",
              render: () => (
                <Tab.Pane>
                  <TobesentBtcAndTbc />
                </Tab.Pane>
              )
            }
          ]}
        />
      </Container>
    );
  }
}

/*
<Table celled>
  <Table.Header>
    <Table.Row>
      <Table.HeaderCell>Name</Table.HeaderCell>
      <Table.HeaderCell>Email</Table.HeaderCell>
      <Table.HeaderCell>Date of sign up</Table.HeaderCell>
      <Table.HeaderCell>Status</Table.HeaderCell>
    </Table.Row>
  </Table.Header>
  <Table.Body>
    {users.map((user, index) => (
      <Table.Row key={index}>
        <Table.Cell>
          <Label ribbon style={{ fontSize: 15 }}>
            {user.name}
          </Label>
        </Table.Cell>
        <Table.Cell>{user.email}</Table.Cell>
        <Table.Cell>{moment(user.date).format("LLLL")}</Table.Cell>
        <Table.Cell>
          {user.activated ? (
            <Fragment>active</Fragment>
          ) : (
            <Button animated onClick={() => this.activate(user.key)}>
              <Button.Content visible>Activate</Button.Content>
              <Button.Content hidden>
                <Icon name="arrow right" />
              </Button.Content>
            </Button>
          )}
        </Table.Cell>
      </Table.Row>
    ))}
  </Table.Body>
</Table>
*/



// WEBPACK FOOTER //
// ./src/views/AdminDash/AdminDashboard.js